/**
 * Created by prog2 on 25/10/2018.
 */

export default {
    message: {
        title: 'JOSEP CLARÀ',
        preferVisitRead: 'Prefiero leer',
        preferVisitListten: 'Prefiero escuchar ',
        downloadAudio: '(descarregar audios)',
        download:'Descarga de los archivos de audio',
        errorDownload: 'Ha habido un error en la descarga.',
        cancelDownload: 'Ha cancelado la descarga.',
        retry: 'Reintentar',
        noConnection: 'No tienes conexión a internet',
        menuItems: [
            {
                idImages: 1,
                title: 'Josep Clarà',
                author: 'Preámbulo',
                description: '',
                // audio: require('./../../assets/audio/ESP/1.mp3')
                audio: '1.mp3'
            },
            {
                idImages: 2,
                title: 'Autorretrato (1898)',
                author: 'Sala 0',
                description: '',
                audio: '2.mp3'

            },
            {
                idImages: 3,
                title: 'Joven florentino (1902)',
                author: 'Sala 0',
                description: '',
                audio: '3.mp3'

            },
            {
                idImages: 4,
                title: 'Éxtasis (1903)',
                author: 'Sala 1',
                description: '',
                audio: '4.mp3'

            },
            {
                idImages: 5,
                title: 'Meditación (1929-1930)',
                author: 'Sala 1',
                description: '.',
                audio: '5.mp3'

            },
            {
                idImages: 6,
                title: 'Vida contemplativa (1917-1918)',
                author: 'Sala 1',
                description: '',
                audio: '6.mp3'

            },
            {
                idImages: 7,
                title: 'Del barro al yeso',
                author: 'Sala 2',
                description: '',
                audio: '7.mp3'

            },
            {
                idImages: 8,
                title: 'Del yeso al mármol',
                author: 'Sala 2',
                description: '',
                audio: '8.mp3'

            },
            {
                idImages: 9,
                title: 'Bronce',
                author: 'Sala 2',
                description: '',
                audio: '9.mp3'

            },
            {
                idImages: 10,
                title: 'Los talleres de París',
                author: 'Sala 2',
                description: '',
                audio: '10.mp3'

            },
            {
                idImages: 11,
                title: 'Dos bailarinas',
                author: 'Sala 3',
                description: '',
                audio: '11.mp3'

            },
            {
                idImages: 12,
                title: 'Cabeza de Adela (1934-1935)',
                author: 'Sala 3',
                description: '',
                audio: '12.mp3'

            },
            {
                idImages: 13,
                title: 'Las hermanas Deering (1923)',
                author: 'Sala 3',
                description: '',
                audio: '13.mp3'

            },
            {
                idImages: 14,
                title: 'Monumentos a los caídos',
                author: 'Sala 4',
                description: '',
                audio: '14.mp3'

            },
            {
                idImages: 15,
                title: 'El Museo Clarà',
                author: 'Sala 4',
                description: '',
                audio: '15.mp3'

            },
            {
                idImages: 16,
                title: 'La diosa (1928)',
                author: 'Sala 4',
                description: '',
                audio: '16.mp3'

            },
            {
                idImages: 17,
                title: 'Créditos',
                isCredits:true,
                author: '',
                description: 'Guion y producción: Trama Media, 2021.<br><br>Textos citados:<br>La traducción del fragmento de la <i>Ilíada</i> es de Lluís Segalà i Estalella.<br>El fragmento de carta de Pablo Gargallo a Josep Clarà se ha extraído del artículo “Els manuscrits i l’epistolari de Josep Clarà: proposta d’antologia”, de Bonaventura Bassegoda i Hugas.<br><br>Músicas:<br>Richard Wagner, <i>Idillio de Sigfrido,</i> (Naxos) y Franz Schubert, <i>Marcha militar Op. 51, II</i> (Naxos).<br><br>Esta audioguía acompaña la exposición ‘Josep Clarà y el universo mediterráneo’, organizada por el Ayuntamiento de Vila-seca y la Fundación Vila Casas con la colaboración del Museo de la Garrotxa, el Ayuntamiento de Olot, el Ayuntamiento de Barcelona, la Filmoteca de Cataluña, el Museo Nacional de Arte de Cataluña y el Museo de la Cerámica de Quart.<br><br>© de las obras y de las imágenes: los autores respectivos.',
                audio: ''
            },

        ]

    }
};



// WEBPACK FOOTER //
// ./src/data/i18n/castellano.js